"use client";
import { createContext, useContext } from "react";
import { LandingSinglePageProps } from "@/types/strapi/landing";

export type LandingSinglePageContextType = LandingSinglePageProps | null;

export const LandingSinglePageContext = createContext<LandingSinglePageContextType>(null);

export const useLandingSinglePageContext = () => useContext(LandingSinglePageContext);
